import React, { memo, useCallback } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import Table from '../binding/table'
import useAreaStore from '../areaStore'

/**
 * 点位绑定规则列表
 */
const BindStandard = function () {
  const { ditto } = useTbViewStore((state) =>
    pick(state, ['layouts', 'ditto', 'setTbData', 'setFields'])
  )

  const { setAreaState, isCreateAreaBind } = useAreaStore((state) =>
    pick(state, ['setAreaState', 'isCreateAreaBind'])
  )

  const getDitto = useAppEx((state) => state.getDitto)
  const standardId = getDitto('standard').tbId

  const loadData = useCallback(
    (page, size) => {
      return ditto.fetchBindRules(standardId, page, size)
    },
    [ditto]
  )

  const onCreate = useCallback(() => {
    setAreaState({
      isCreateAreaBind: true,
      areaBindType: 'standard',
      ruleId: null,
    })
  }, [])

  const onModify = useCallback((item) => {
    setAreaState({
      isCreateAreaBind: true,
      areaBindType: 'standard',
      ruleId: item.id,
      ruleName: item.ruleName,
    })
  }, [])

  const onSwitch = useCallback(
    (...args) => {
      return ditto.switchBindRule(...args)
    },
    [ditto]
  )

  return (
    <Table
      loadData={loadData}
      onCreate={onCreate}
      onModify={onModify}
      switcher={onSwitch}
      visible={!isCreateAreaBind}
    />
  )
}

export default memo(BindStandard)
